import React from "react";
import HudHeader from "../components/header/HudHeader";
import HudSidebar from "../components/sidebar/HudSidebar";

const HudLayout = ({ children, noSidebar }) => {
  return (
    <div className="flex flex-col h-screen bg-[#F4FAF1]">
      {!noSidebar && <HudHeader />}
      <div className="flex flex-1 h-screen overflow-hidden">
        {!noSidebar && <HudSidebar />}
        <main className={"flex-1 overflow-y-auto" + `${noSidebar ? "" : " p-4 sm:ml-1"}`}>{children}</main>
      </div>
    </div >
  );
};

export default HudLayout;
